<template>
  <div class="q-page">
    <div class="container py-5">

      <nav aria-label="breadcrumb" class="mb-4">
        <ol class="breadcrumb q-breadcrumb">
          <li class="breadcrumb-item"><router-link :to="{ name: 'Home' }">Inicio</router-link></li>
          <li class="breadcrumb-item active">Políticas de devolución</li>
        </ol>
      </nav>

      <div class="row justify-content-center">
        <div class="col-lg-8">
          <p class="q-section-title mb-4">Políticas de devolución</p>

          <!-- Condiciones generales -->
          <div class="q-policy-block">
            <h2 class="q-policy-subtitle">Condiciones generales</h2>
            <ul class="q-policy-list">
              <li>Tenés <strong>72 horas</strong> desde la recepción del pedido para informar cualquier problema o reclamo al asesor online.</li>
              <li>Disponés de <strong>7 días hábiles</strong> desde la recepción para efectuar el cambio, siempre que el producto no haya sido utilizado o presente fallas de fabricación.</li>
              <li>El artículo debe devolverse en perfectas condiciones, con empaquetado original, packaging intacto y sin signos de uso.</li>
              <li>Si el producto presenta defectos, debe enviarse en condiciones de higiene junto con la factura de compra.</li>
            </ul>
          </div>

          <!-- Motivos de cambio -->
          <div class="q-policy-block">
            <h2 class="q-policy-subtitle">Motivos de cambio o devolución</h2>

            <div class="q-policy-reason">
              <p class="q-policy-reason__title">Falla o defecto de fábrica</p>
              <p>El producto se reemplazará por otro del mismo código, siempre que esté disponible.</p>
            </div>

            <div class="q-policy-reason">
              <p class="q-policy-reason__title">Error en el artículo recibido (color, tamaño, modelo, etc.)</p>
              <p>Se puede cambiar por el artículo correcto, mediante entrega en local o por envío a cargo de Jade.</p>
            </div>

            <div class="q-policy-reason">
              <p class="q-policy-reason__title">Confusión del cliente</p>
              <p>Si el cliente solicitó un modelo distinto (por ejemplo: cables V8 vs TC, variantes de producto, etc.), puede solicitar el cambio si cumple las condiciones mencionadas.</p>
            </div>

            <div class="q-policy-reason">
              <p class="q-policy-reason__title">Productos del rubro maquillaje</p>
              <p>En compras online exclusivamente, se debe informar el defecto el mismo día de recepción. De no hacerlo en ese plazo, no procede el cambio.</p>
            </div>

            <div class="q-policy-reason q-policy-reason--note">
              <i class="bi bi-info-circle me-2"></i>
              <p><strong>Nota de crédito:</strong> si un producto defectuoso no tiene stock para reemplazo, se otorgará una nota de crédito por el valor del artículo.</p>
            </div>
          </div>

          <!-- Procedimiento -->
          <div class="q-policy-block">
            <h2 class="q-policy-subtitle">Procedimiento para realizar el cambio</h2>
            <p class="mb-3">Para gestionar un cambio o devolución, seguí estos pasos:</p>

            <div class="q-procedure-step">
              <span class="q-procedure-step__num">1</span>
              <div>
                <p class="q-procedure-step__title">Contactanos por WhatsApp indicando:</p>
                <ul class="q-policy-list">
                  <li>Nombre completo asociado a la cuenta</li>
                  <li>Número de factura o pedido</li>
                  <li>Código del producto</li>
                  <li>Cantidad</li>
                  <li>Motivo del cambio</li>
                  <li>Dirección completa de envío (si corresponde)</li>
                </ul>
              </div>
            </div>

            <div class="q-procedure-step">
              <span class="q-procedure-step__num">2</span>
              <div>
                <p class="q-procedure-step__title">Embalá el producto con cuidado:</p>
                <ul class="q-policy-list">
                  <li>Utilizá su caja original o un envoltorio que asegure su integridad</li>
                  <li>Si devolvés más de un producto, unilos en una misma caja o bolsa</li>
                  <li>Adjuntá la factura y todos los datos pedidos al paquete</li>
                </ul>
              </div>
            </div>

            <div class="q-procedure-step">
              <span class="q-procedure-step__num">3</span>
              <div>
                <p class="q-procedure-step__title">Enviá el producto dentro del plazo indicado.</p>
                <p>El producto debe llegar en el mismo estado en que fue recibido.</p>
              </div>
            </div>
          </div>

          <!-- Opciones disponibles -->
          <div class="q-policy-block">
            <h2 class="q-policy-subtitle">Opciones disponibles al aprobarse la devolución</h2>

            <div class="q-policy-reason">
              <p class="q-policy-reason__title">Cambio por el mismo producto</p>
              <p>Si hay stock del artículo original, se reemplazará por el mismo.</p>
            </div>

            <div class="q-policy-reason">
              <p class="q-policy-reason__title">Cambio por modelo equivalente</p>
              <p>Si el cliente prefiere otro modelo o variante, se puede hacer el cambio si cumple las condiciones.</p>
            </div>

            <div class="q-policy-reason">
              <p class="q-policy-reason__title">Nota de crédito</p>
              <p>Si no existe stock para reemplazo, se emitirá una nota de crédito por el monto del producto, válida para usar en compras posteriores.</p>
            </div>
          </div>

          <!-- Excepciones -->
          <div class="q-policy-block">
            <h2 class="q-policy-subtitle">Excepciones y aspectos importantes</h2>
            <ul class="q-policy-list">
              <li>No aceptamos devoluciones de artículos usados, dañados por el cliente o con faltantes de componentes o etiquetas.</li>
              <li>Cambios de productos tipo maquillaje solo aplican si se reportan el mismo día de recepción.</li>
              <li>Los cambios deben iniciarse dentro de los plazos señalados (72 horas + 7 días hábiles).</li>
              <li>Los costos de envío por devolución son asumidos por el cliente, salvo que la causa sea daño o defecto de fábrica.</li>
              <li>Las devoluciones fuera del plazo o que no cumplan con las condiciones no serán procesadas.</li>
            </ul>
          </div>

          <!-- Contacto -->
          <div class="q-help-box mt-2">
            <i class="bi bi-whatsapp q-help-box__icon"></i>
            <div>
              <p class="q-help-box__title">Contacto para devoluciones</p>
              <p class="q-help-box__text">Ante cualquier consulta sobre devoluciones o cambios, escribinos por WhatsApp indicando los datos requeridos. Estamos disponibles para ayudarte a resolver cualquier inconveniente.</p>
              <a v-if="whatsappUrl" :href="whatsappUrl" target="_blank" class="btn btn-primary btn-sm mt-2">
                <i class="bi bi-whatsapp me-1"></i>Escribinos por WhatsApp
              </a>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ReturnPolicy",
  computed: {
    ...mapGetters({ networks: "ecommerce/networks" }),
    whatsappUrl() {
      return this.networks && this.networks.whatsapp
        ? `https://wa.me/54${this.networks.whatsapp}`
        : null;
    },
  },
};
</script>

<style scoped>
.q-breadcrumb { background: transparent; padding: 0; margin: 0; }
.q-breadcrumb .breadcrumb-item { font-size: 14px; color: var(--q-text-subtle); }
.q-breadcrumb .breadcrumb-item a { color: var(--q-text-muted); }
.q-breadcrumb .breadcrumb-item a:hover { color: var(--primary-color); }
.q-breadcrumb .breadcrumb-item + .breadcrumb-item::before { color: var(--q-text-subtle); }

.q-policy-block {
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid var(--q-border);
}
.q-policy-block:last-child { border-bottom: none; }

.q-policy-subtitle {
  font-family: var(--q-font-display);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--q-text);
  margin-bottom: 14px;
}

.q-policy-block p {
  font-size: 14px;
  line-height: 1.8;
  color: var(--q-text-muted);
  margin: 0;
}

.q-policy-list {
  margin: 8px 0 0 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.q-policy-list li {
  font-size: 14px;
  line-height: 1.7;
  color: var(--q-text-muted);
}

/* Reason blocks */
.q-policy-reason {
  margin-bottom: 16px;
  padding-left: 12px;
  border-left: 2px solid var(--q-border);
}
.q-policy-reason__title {
  font-family: var(--q-font-display);
  font-size: 13px;
  font-weight: 700;
  color: var(--q-text) !important;
  margin-bottom: 4px !important;
  letter-spacing: 0.02em;
}
.q-policy-reason--note {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  border-left-color: var(--primary-color);
  background-color: rgba(var(--primary-color-rgb, 0,150,200), 0.05);
  padding: 10px 12px;
  border-radius: 0 var(--q-radius) var(--q-radius) 0;
}
.q-policy-reason--note i { color: var(--primary-color); margin-top: 2px; flex-shrink: 0; }
.q-policy-reason--note p { margin: 0 !important; font-size: 13px; }

/* Procedure steps */
.q-procedure-step {
  display: flex;
  gap: 14px;
  margin-bottom: 16px;
}
.q-procedure-step__num {
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: var(--primary-color);
  color: #fff;
  font-family: var(--q-font-mono);
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
}
.q-procedure-step__title {
  font-weight: 600;
  color: var(--q-text) !important;
  margin-bottom: 6px !important;
}

/* Help box */
.q-help-box {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background-color: var(--q-bg-elevated);
  border: 1px solid var(--q-border);
  border-left: 3px solid var(--primary-color);
  border-radius: var(--q-radius);
  padding: 20px 24px;
}
.q-help-box__icon {
  font-size: 28px;
  color: var(--primary-color);
  flex-shrink: 0;
  margin-top: 2px;
}
.q-help-box__title {
  font-family: var(--q-font-display);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--q-text);
  margin: 0 0 4px;
}
.q-help-box__text {
  font-size: 13px;
  color: var(--q-text-muted);
  margin: 0;
  line-height: 1.7;
}
</style>
